import React, { useState } from 'react';
import styled from 'styled-components';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import PayPalButtonActiveStatus from '../components/payment/PayPalButtonActiveStatus';
const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 0;
`;

const ProductSection = styled.section`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const ProductCard = styled.div`
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 3rem;
  transform: translateY(0);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }
`;

const ProductHeader = styled.div`
  background: linear-gradient(135deg, #2563eb 0%, #10b981 100%);
  color: white;
  padding: 2rem;
  text-align: center;
  position: relative;
`;

const ProductIcon = styled.span`
  font-size: 4rem;
  display: block;
  margin-bottom: 1rem;
`;

const ProductTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const ProductTag = styled.span`
  background: rgba(255, 255, 255, 0.2);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
`;

const ProductBody = styled.div`
  padding: 1.5rem 2rem;
`;

const ProductDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  color: #4a5568;
  margin-bottom: 1rem;
  text-align: center;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 auto 0.5rem auto;
  max-width: 600px;
  text-align: left;
`;

const FeatureItem = styled.li`
  color: #4a5568;
  font-size: 0.95rem;
  line-height: 1.4;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: flex-start;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  &::before {
    content: '✓';
    color: #10b981;
    margin-right: 0.5rem;
    font-weight: bold;
    flex-shrink: 0;
  }
`;

const ProductFooter = styled.div`
  background: #f8fafc;
  padding: 2rem;
  text-align: center;
  border-top: 1px solid #e2e8f0;
`;

const ProductPrice = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: #2563eb;
  margin-bottom: 1rem;
  
  span {
    font-size: 1rem;
    color: #64748b;
    font-weight: 500;
  }
`;

const BuyButton = styled.button<{ disabled?: boolean }>`
  background: linear-gradient(135deg, #2563eb 0%, #10b981 100%);
  color: white;
  border: none;
  padding: 1rem 3rem;
  border-radius: 50px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  opacity: ${props => props.disabled ? 0.6 : 1};
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(37, 99, 235, 0.3);
  }
`;

const CheckoutSection = styled.div`
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 600px;
  margin: 0 auto;
`;

const CheckoutTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const OrderSummary = styled.div`
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
`;

const OrderItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #e2e8f0;
  color: #1a202c;
  
  &:last-child {
    border-bottom: none;
    font-weight: 600;
    color: #2563eb;
  }
`;

// PRECIO CENTRALIZADO - CAMBIAR SOLO AQUÍ
const PRODUCT_PRICE = 49.90;

const ActiveStatusProPage: React.FC = () => {
  const [pageState, setPageState] = useState<'product' | 'checkout' | 'success'>('product');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerName, setCustomerName] = useState('Cliente ActiveStatusPro');

  const handleProceedToCheckout = () => {
    setPageState('checkout');
  };

  const handlePaymentSuccess = async (details: any) => {
    console.log('Payment successful:', details);
    
    // Extraer datos del pagador de PayPal
    const name = details.payer?.name?.given_name + ' ' + details.payer?.name?.surname || 'Cliente ActiveStatusPro';
    const email = details.payer?.email_address || '';
    
    setCustomerName(name);
    setCustomerEmail(email);
    
    // Cambiar a pantalla de éxito INMEDIATAMENTE
    setPageState('success');
    
    // El email ya fue enviado automáticamente por el endpoint /confirmar
    console.log('Pago completado y email enviado automáticamente por backend');
  };

  const handlePaymentError = (error: any) => {
    console.error('Payment error:', error);
    alert('Hubo un error procesando el pago. Por favor intenta nuevamente.');
  };

  const handlePaymentCancel = () => {
    console.log('Payment cancelled');
  };

  const features = [
    "Trabajo remoto flexible",
    "Evitar que tu status cambie a 'ausente' automáticamente", 
    "Mantener visibilidad en Teams, Slack, Zoom, Discord",
    "Pausas de café sin cambiar a 'ausente'",
    "Mantener conexiones remotas activas",
    "Flexibilidad en tu horario sin perder disponibilidad"
  ];

  return (
    <Container>
        <ProductSection>
          {pageState === 'product' ? (
            <ProductCard>
              <ProductHeader>
                <ProductIcon>💻</ProductIcon>
                <ProductTitle>ActiveStatusPro</ProductTitle>
                <ProductTag>Productividad Remota</ProductTag>
              </ProductHeader>
              
              <ProductBody>
                <ProductDescription>
                  Herramienta de productividad para trabajadores remotos. Mantén tu computadora activa y tu estado visible en herramientas de trabajo remoto.
                </ProductDescription>
                
                <FeaturesList>
                  {features.map((feature, index) => (
                    <FeatureItem key={index}>
                      {feature}
                    </FeatureItem>
                  ))}
                </FeaturesList>
                
                <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                  <a 
                    href="https://dynappmos.com/activestatuspro.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#2563eb',
                      textDecoration: 'underline',
                      fontSize: '1rem'
                    }}
                  >
                    Regresar a ActivestatusPro
                  </a>
                </div>
              </ProductBody>
              
              <ProductFooter>
                <ProductPrice>
                  ${PRODUCT_PRICE.toFixed(2)} <span>USD</span>
                </ProductPrice>
                <BuyButton onClick={handleProceedToCheckout}>
                  Procede al pago
                </BuyButton>
              </ProductFooter>
            </ProductCard>
          ) : pageState === 'checkout' ? (
            <CheckoutSection>
              <CheckoutTitle>Finalizar Compra</CheckoutTitle>
              
              <OrderSummary>
                <OrderItem>
                  <span>ActiveStatusPro</span>
                  <span>${PRODUCT_PRICE.toFixed(2)}</span>
                </OrderItem>
                <OrderItem>
                  <span>Subtotal</span>
                  <span>${PRODUCT_PRICE.toFixed(2)}</span>
                </OrderItem>
                <OrderItem>
                  <span>Total</span>
                  <span>${PRODUCT_PRICE.toFixed(2)} USD</span>
                </OrderItem>
              </OrderSummary>
              
              <PayPalButtonActiveStatus
                amount={PRODUCT_PRICE}
                onSuccess={handlePaymentSuccess}
                onError={handlePaymentError}
                onCancel={handlePaymentCancel}
              />
              
              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <button 
                  onClick={() => setPageState('product')}
                  style={{
                    background: 'transparent',
                    border: '1px solid #e2e8f0',
                    color: '#64748b',
                    padding: '0.5rem 1rem',
                    borderRadius: '8px',
                    cursor: 'pointer'
                  }}
                >
                  ← Volver al producto
                </button>
              </div>
            </CheckoutSection>
          ) : (
            // SUCCESS STATE
            <CheckoutSection>
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
                <h2 style={{ color: '#10b981', fontSize: '2rem', marginBottom: '1rem' }}>
                  ¡Gracias por tu compra!
                </h2>
                <p style={{ fontSize: '1.2rem', color: '#4a5568', marginBottom: '1rem' }}>
                  Tu pago de <strong>${PRODUCT_PRICE.toFixed(2)} USD</strong> fue procesado exitosamente.
                </p>
                <p style={{ fontSize: '1rem', color: '#4a5568', marginBottom: '2rem' }}>
                  Te enviaremos las instrucciones de descarga a tu email: <br />
                  <strong>{customerEmail}</strong>
                </p>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <button 
                    onClick={() => setPageState('product')}
                    style={{
                      background: 'linear-gradient(135deg, #2563eb 0%, #10b981 100%)',
                      color: 'white',
                      border: 'none',
                      padding: '1rem 2rem',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '1rem',
                      fontWeight: '600'
                    }}
                  >
                    Comprar otro producto
                  </button>
                  <button 
                    onClick={() => window.location.href = 'https://canvasoft.com'}
                    style={{
                      background: 'transparent',
                      border: '1px solid #e2e8f0',
                      color: '#64748b',
                      padding: '1rem 2rem',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '1rem'
                    }}
                  >
                    Ir a Inicio
                  </button>
                </div>
              </div>
            </CheckoutSection>
          )}
        </ProductSection>
    </Container>
  );
};

export default ActiveStatusProPage;